module.exports = __webpack_public_path__ + "static/media/createsavesticon.f3867f4e.svg";